const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    data-name="XP iGamio 20 px"
    width={30.41}
    height={20}
    {...props}>
    <defs>
      <clipPath id="f">
        <path data-name="Rectangle 2622" fill="none" d="M0 0h30.41v20H0z" />
      </clipPath>
      <clipPath id="g">
        <path
          data-name="Path 10199"
          d="M31.82 7.5c-.255.506 2.461 12.64 3.089 13.259s5.144-.085 5.144-.085L35.127 6.1s-3.051.893-3.307 1.4"
          transform="translate(-31.803 -6.105)"
          fill="none"
        />
      </clipPath>
      <clipPath id="h">
        <path
          data-name="Path 10200"
          d="M45.891 8.927c-.642-.049-1.023-2.732-.95-3.538s3.385-1.47 4.282.448c.869 1.863-2.279 3.093-3.256 3.093h-.076m-6.357-6.093c-.467.439 1.964 14.026 2.371 14.4s3.789.2 4.042-.212a17.684 17.684 0 0 0 .043-3.61s4.114-.2 5.3-1.38c1.535-1.518 2.065-4.427 1.654-6.942-.323-2-1.24-3.745-2.729-4.354a5.155 5.155 0 0 0-1.932-.324c-3.64 0-8.749 2.422-8.749 2.422"
          transform="translate(-39.474 -.415)"
          fill="none"
        />
      </clipPath>
      <clipPath id="i">
        <path
          data-name="Path 10201"
          d="M47.795 12.376a1.827 1.827 0 0 1-1.255-.665c-.918-1.083-1.113-3.767-1.048-4.471.091-.994.98-1.754 2.345-2.029h.011a5.79 5.79 0 0 1 .279-.047A4.056 4.056 0 0 1 52.571 7.2a2.884 2.884 0 0 1-.071 2.638 5.878 5.878 0 0 1-4.051 2.51 3.12 3.12 0 0 1-.271.028c-.069 0-.135.007-.2.007s-.127 0-.188-.007m1.175-8.4a5.54 5.54 0 0 0-.258.041h-.029a27.588 27.588 0 0 0-5.7 1.775c.032.4.1.941.182 1.568.425 3.171 1.406 8.629 1.886 10.585.28.008.636 0 1-.018.188-.012.378-.029.561-.051.008-.644-.026-1.59-.077-2.389l-.089-1.436v-.052l1.49-.074s.188-.012.485-.037c.224-.018.51-.048.831-.091l.087-.012c.08-.008.16-.019.241-.031a6.156 6.156 0 0 0 2.7-.787c1.092-1.079 1.606-3.491 1.231-5.7a4.124 4.124 0 0 0-.043-.243c-.3-1.51-.968-2.614-1.786-2.945a3.671 3.671 0 0 0-1.377-.208 9.277 9.277 0 0 0-1.326.106"
          transform="translate(-42.983 -3.871)"
          fill="none"
        />
      </clipPath>
      <clipPath id="j">
        <path
          data-name="Path 10202"
          d="M47.234 12.566a1.837 1.837 0 0 1-1.255-.666c-.918-1.083-1.113-3.767-1.047-4.471.1-1.062 1.106-1.858 2.635-2.079.091-.013.182-.023.27-.031h.011a5.79 5.79 0 0 1 .279-.047 4.056 4.056 0 0 1 4.445 2.036 2.884 2.884 0 0 1-.072 2.638 5.878 5.878 0 0 1-4.051 2.51 3.12 3.12 0 0 1-.271.028c-.1.022-.2.04-.289.053a3.225 3.225 0 0 1-.461.036c-.068 0-.132 0-.2-.008m1.478-8.44h-.029a27.588 27.588 0 0 0-5.7 1.775c.2 2.446 1.492 9.81 2.068 12.153.28.008.636 0 1-.018.008-.64-.026-1.572-.077-2.36l-.093-1.487.564-.03.926-.045s.188-.012.485-.037a20.352 20.352 0 0 0 1.391-.171l.087-.012a5.9 5.9 0 0 0 2.375-.737c1.2-.993 1.876-2.447 1.189-5.942a3.857 3.857 0 0 0-1.786-2.945 3.622 3.622 0 0 0-1.374-.213 8.754 8.754 0 0 0-1.029.066"
          transform="translate(-42.983 -4.059)"
          fill="none"
        />
      </clipPath>
      <clipPath id="k">
        <path
          data-name="Path 10203"
          d="M52.3 11.021c-.073.806.307 3.489.95 3.538.876.07 4.226-1.176 3.332-3.09a2.441 2.441 0 0 0-2.338-1.247c-.994 0-1.906.381-1.944.8"
          transform="translate(-52.296 -10.222)"
          fill="none"
        />
      </clipPath>
      <clipPath id="n">
        <path
          data-name="Path 10205"
          d="M41.922 0a16.647 16.647 0 0 0-10.561 4.117 10.44 10.44 0 0 1 3.472-1.065C40.6.106 44.652.253 44.652.253A14.527 14.527 0 0 0 41.989 0Z"
          transform="translate(-31.361)"
          fill="none"
        />
      </clipPath>
      <clipPath id="o">
        <path data-name="Rectangle 2589" fill="none" d="M0 0h4.168v3.162H0z" />
      </clipPath>
      <clipPath id="p">
        <path data-name="Rectangle 2590" fill="none" d="M0 0h3.792v12.915H0z" />
      </clipPath>
      <clipPath id="q">
        <path data-name="Rectangle 2591" fill="none" d="M0 0h4.598v.361H0z" />
      </clipPath>
      <clipPath id="r">
        <path data-name="Rectangle 2592" fill="none" d="M0 0h7.091v8.322H0z" />
      </clipPath>
      <clipPath id="s">
        <path
          data-name="Path 10210"
          d="M53.9 18.8c.367.455 1.444.077 2.184-.322a3.864 3.864 0 0 0 .768-.541c-1.971 1.319-2.952.862-2.952.862"
          transform="translate(-53.902 -17.935)"
          fill="none"
        />
      </clipPath>
      <clipPath id="u">
        <path data-name="Rectangle 2595" fill="none" d="M0 0h10.52v3.702H0z" />
      </clipPath>
      <clipPath id="v">
        <path data-name="Rectangle 2596" fill="none" d="M0 0h6.399v3.129H0z" />
      </clipPath>
      <clipPath id="w">
        <path
          data-name="Path 10213"
          d="M49.793 25.129a18.038 18.038 0 0 0 4.543-.356c2.413-.513 2.492-1.669 2.492-1.669s-1.673 2.067-7.035 2.025"
          transform="translate(-49.793 -23.104)"
          fill="none"
        />
      </clipPath>
      <clipPath id="y">
        <path data-name="Rectangle 2599" fill="none" d="M0 0h1.066v.879H0z" />
      </clipPath>
      <clipPath id="z">
        <path
          data-name="Path 10216"
          d="M48.825 36.242a6.428 6.428 0 0 1-1.094-.068s-.017.192.093.213a7.692 7.692 0 0 0 1.515-.089.951.951 0 0 0 0-.356s-.057.273-.515.3"
          transform="translate(-47.73 -35.942)"
          fill="none"
        />
      </clipPath>
      <clipPath id="B">
        <path
          data-name="Path 10217"
          d="M12.569 7.53a25.909 25.909 0 0 0-1.669 2.556 278.722 278.722 0 0 0-3.44 5.822 34.19 34.19 0 0 0-2.022 3.8c-.1.68 1.277 1.588 2.288 2.564a2.634 2.634 0 0 0 .212.206.159.159 0 0 0 .153 0c1.482-.515 7.865-15.694 7.865-15.694a1.807 1.807 0 0 0-.531-.067 6.342 6.342 0 0 0-2.854.809"
          transform="translate(-5.431 -6.721)"
          fill="none"
        />
      </clipPath>
      <clipPath id="D">
        <path
          data-name="Path 10218"
          d="M4.514 10.248a5.925 5.925 0 0 0-2.558.8C1.2 11.684-.258 14.736.04 15.819s4.944 3.274 4.944 3.274l2.479.1L2.829 14.9l1.845-4.657Z"
          transform="translate(0 -10.242)"
          fill="none"
        />
      </clipPath>
      <clipPath id="F">
        <path
          data-name="Path 10219"
          d="M12 11.3c-.529-.4-1.041-.778-1.525-1.121C8.8 8.98 7.5 8.187 7.207 8.315c-.943.415-3.826 4.075-1.833 6.37A15.522 15.522 0 0 0 7.031 16c.424.314.917.663 1.443 1.033a17.885 17.885 0 0 0-1.788 3.695 1.847 1.847 0 0 0 .45 1.44c.05.067.1.134.162.2a2.634 2.634 0 0 0 .212.206 6.687 6.687 0 0 0 2.543 1.375.161.161 0 0 0 .039.006h.014c.326-.011 1.088-.744 2.041-1.839.036-.039.071-.077.1-.115s.045-.051.064-.072c.391-.458.811-.968 1.246-1.51 2.212 1.375 4.1 2.391 4.46 2.142.916-.63 2.91-2.616 2.105-4.15a17.811 17.811 0 0 0-2.9-2.873 32.673 32.673 0 0 0 2.142-3.249c1.121-2.833-2.817-5.326-3.843-5.4h-.011c-.427 0-1.9 1.963-3.52 4.42"
          transform="translate(-4.687 -6.878)"
          fill="none"
        />
      </clipPath>
      <clipPath id="H">
        <path
          data-name="Path 10220"
          d="M18.042 12.283c-.473.611-1.14 1.547-2.034 2.895l-1.079 1.635-.463-.349-1.1-.833c-1.615-1.223-2.684-1.942-3.311-2.323-.1.122-.2.259-.3.407a4.21 4.21 0 0 0-.736 1.723 1.073 1.073 0 0 0 .193.878c.218.195 1.131.907 2.8 2.078l1.368.958-.828 1.448A23.755 23.755 0 0 0 11 23.829a2.634 2.634 0 0 0 .876.713 4.669 4.669 0 0 0 .434.231 30.842 30.842 0 0 0 2.29-2.641l.707-.886.315-.391 1.387.862c1.2.748 2.018 1.21 2.556 1.489.18.093.329.168.452.224a3.533 3.533 0 0 0 .927-1.326 24.193 24.193 0 0 0-2.444-2.319l-1.257-1.093.966-1.362c1.183-1.661 1.808-2.635 1.949-2.893a.885.885 0 0 0 .053-.327 1.316 1.316 0 0 0-.164-.571 4.723 4.723 0 0 0-1.675-1.664c-.095.114-.2.252-.327.412"
          transform="translate(-9.004 -11.871)"
          fill="none"
        />
      </clipPath>
      <clipPath id="J">
        <path
          data-name="Path 10221"
          d="m16.008 15.733-1.079 1.635-.768.111L12.6 16.3a51.533 51.533 0 0 0-2.842-2.027 4.21 4.21 0 0 0-.736 1.723 1.073 1.073 0 0 0 .193.878c.218.195 1.131.907 2.8 2.078l1.368.958-.826 1.453A23.756 23.756 0 0 0 11 24.385a2.634 2.634 0 0 0 .876.713c.418-.443 1.047-1.162 1.956-2.3l1.02-1.277.768-.111 1.387.862c1.2.748 2.018 1.21 2.556 1.489a2.726 2.726 0 0 0 .611-.991 23.808 23.808 0 0 0-2.449-2.317l-1.258-1.093.972-1.36c1.183-1.661 1.808-2.636 1.949-2.894a1.077 1.077 0 0 0-.108-.9 4.2 4.2 0 0 0-1.237-1.363c-.473.611-1.14 1.547-2.034 2.895"
          transform="translate(-9.004 -12.838)"
          fill="none"
        />
      </clipPath>
      <clipPath id="L">
        <path
          data-name="Path 10222"
          d="M24.383 39.275a16.179 16.179 0 0 0 4.946 1.54 13.944 13.944 0 0 1-4.457-2.145Z"
          transform="translate(-24.383 -38.67)"
          fill="none"
        />
      </clipPath>
      <clipPath id="N">
        <path
          data-name="Path 10223"
          d="M4.594 10.818a4.665 4.665 0 0 1 2.162-.53c1.5-.087 4.458 2.167 4.458 2.167S8.3 10.125 7.327 9.878a1.178 1.178 0 0 0-.293-.034 5.889 5.889 0 0 0-2.44.974"
          transform="translate(-4.594 -9.844)"
          fill="none"
        />
      </clipPath>
      <clipPath id="P">
        <path
          data-name="Path 10224"
          d="M20.578 7.562s-1.153 1.764-.982 2.3 1.273.516 2.237-.525S24.08 6.8 24.08 6.8a2.776 2.776 0 0 0-.615-.056 6.1 6.1 0 0 0-2.887.815"
          transform="translate(-19.579 -6.747)"
          fill="none"
        />
      </clipPath>
      <clipPath id="R">
        <path data-name="Rectangle 2610" fill="none" d="M0 0h5.538v3.126H0z" />
      </clipPath>
      <clipPath id="S">
        <path data-name="Rectangle 2611" fill="none" d="M0 0h3.178v1.665H0z" />
      </clipPath>
      <clipPath id="T">
        <path data-name="Rectangle 2612" fill="none" d="M0 0h7.143v4.152H0z" />
      </clipPath>
      <clipPath id="U">
        <path data-name="Rectangle 2613" fill="none" d="M0 0h2.813v4.727H0z" />
      </clipPath>
      <clipPath id="V">
        <path
          data-name="Path 10229"
          d="M28.353 22.155a14.153 14.153 0 0 0 2.852-4.116c-.425.779-2.852 4.116-2.852 4.116m2.852-4.116a.59.59 0 0 0 .063-.14s-.021.05-.063.14"
          transform="translate(-28.353 -17.899)"
          fill="none"
        />
      </clipPath>
      <clipPath id="X">
        <path
          data-name="Path 10230"
          d="m15.594 26.837-2.525-1.787s1.75 1.734 2.525 1.787"
          transform="translate(-13.069 -25.05)"
          fill="none"
        />
      </clipPath>
      <clipPath id="Z">
        <path data-name="Rectangle 2617" fill="none" d="M0 0h11.204v6.062H0z" />
      </clipPath>
      <clipPath id="aa">
        <path data-name="Rectangle 2618" fill="none" d="M0 0h1.01v.829H0z" />
      </clipPath>
      <clipPath id="ab">
        <path
          data-name="Path 10235"
          d="M33.944 37.117c-.319.163-.938-.183-.938-.183a3.23 3.23 0 0 0 .773.48c.28.078.929-1.317.929-1.317s-.445.857-.764 1.02"
          transform="translate(-33.006 -36.097)"
          fill="none"
        />
      </clipPath>
      <clipPath id="ad">
        <path
          data-name="Path 10236"
          d="M14.97 40.271c-.409.055-1.267-.795-1.267-.795a3.9 3.9 0 0 0 1.126 1.01c.578.278 1.374-1.371 1.374-1.371s-.825 1.1-1.233 1.156"
          transform="translate(-13.703 -39.115)"
          fill="none"
        />
      </clipPath>
      <linearGradient
        id="c"
        x1={-1.157}
        y1={1.098}
        x2={-1.117}
        y2={1.098}
        gradientUnits="objectBoundingBox">
        <stop offset={0} stopColor="#ff4b00" />
        <stop offset={0.05} stopColor="#ff4b00" />
        <stop offset={1} stopColor="#ff7204" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={-0.918}
        y1={1.09}
        x2={-0.892}
        y2={1.09}
        gradientUnits="objectBoundingBox">
        <stop offset={0} stopColor="#ffa200" />
        <stop offset={1} stopColor="#ffb82f" />
      </linearGradient>
      <linearGradient
        id="a"
        x1={-1.355}
        y1={1.231}
        x2={-1.322}
        y2={1.231}
        gradientUnits="objectBoundingBox">
        <stop offset={0} stopColor="#ff7234" />
        <stop offset={1} stopColor="#ff5e00" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={-1.388}
        y1={1.233}
        x2={-1.354}
        y2={1.233}
        gradientUnits="objectBoundingBox">
        <stop offset={0} stopColor="#de0500" />
        <stop offset={1} stopColor="#ff2d00" />
      </linearGradient>
      <linearGradient
        id="l"
        x1={-3.761}
        y1={3.125}
        x2={-3.688}
        y2={3.125}
        gradientUnits="objectBoundingBox">
        <stop offset={0} stopColor="#ffa200" />
        <stop offset={1} stopColor="#ffc234" />
      </linearGradient>
      <linearGradient id="m" x1={-3.761} y1={3.125} x2={-3.688} y2={3.125} xlinkHref="#a" />
      <linearGradient
        id="b"
        x1={-0.955}
        y1={3.502}
        x2={-0.924}
        y2={3.502}
        gradientUnits="objectBoundingBox">
        <stop offset={0} stopColor="#ffde00" />
        <stop offset={1} stopColor="#ffe834" />
      </linearGradient>
      <linearGradient id="t" x1={-7.353} y1={7.288} x2={-7.216} y2={7.288} xlinkHref="#b" />
      <linearGradient id="x" x1={-2.897} y1={3.367} x2={-2.839} y2={3.367} xlinkHref="#b" />
      <linearGradient id="A" x1={-11.799} y1={6.91} x2={-11.551} y2={6.91} xlinkHref="#b" />
      <linearGradient
        id="C"
        x1={-0.089}
        y1={1.04}
        x2={-0.056}
        y2={1.04}
        gradientUnits="objectBoundingBox">
        <stop offset={0} stopColor="#ff5e00" />
        <stop offset={0.545} stopColor="#ff691c" />
        <stop offset={1} stopColor="#ffff34" />
      </linearGradient>
      <linearGradient id="E" x1={0.096} y1={1.62} x2={0.144} y2={1.62} xlinkHref="#c" />
      <linearGradient id="G" x1={0.022} y1={0.94} x2={0.044} y2={0.94} xlinkHref="#d" />
      <linearGradient id="I" x1={-0.214} y1={1.087} x2={-0.183} y2={1.087} xlinkHref="#a" />
      <linearGradient id="K" x1={-0.231} y1={1.112} x2={-0.198} y2={1.112} xlinkHref="#e" />
      <linearGradient id="M" x1={-1.971} y1={1.369} x2={-1.889} y2={1.369} xlinkHref="#c" />
      <linearGradient id="O" x1={-0.26} y1={4.604} x2={-0.199} y2={4.604} xlinkHref="#b" />
      <linearGradient id="Q" x1={-1.548} y1={4.076} x2={-1.465} y2={4.076} xlinkHref="#b" />
      <linearGradient id="W" x1={-3.372} y1={2.715} x2={-3.25} y2={2.715} xlinkHref="#b" />
      <linearGradient id="Y" x1={-1.978} y1={4.464} x2={-1.823} y2={4.464} xlinkHref="#b" />
      <linearGradient id="ac" x1={-7.41} y1={2.928} x2={-7.184} y2={2.928} xlinkHref="#b" />
      <linearGradient id="ae" x1={-2.114} y1={1.766} x2={-1.957} y2={1.766} xlinkHref="#b" />
    </defs>
    <g data-name="Group 7751" clipPath="url(#f)">
      <g data-name="Group 7659">
        <g data-name="Group 7658" clipPath="url(#g)" transform="translate(13.538 2.599)">
          <path
            data-name="Rectangle 2582"
            transform="rotate(-8.223 .97 16.85)"
            fill="url(#c)"
            d="M0 0h10.585v16.328H0z"
          />
        </g>
      </g>
      <g data-name="Group 7661">
        <g data-name="Group 7660" clipPath="url(#h)" transform="translate(16.804 .177)">
          <path
            data-name="Rectangle 2583"
            transform="rotate(-8.223 1.027 19.944)"
            fill="url(#d)"
            d="M0 0h16.604v19.063H0z"
          />
        </g>
      </g>
      <g data-name="Group 7663">
        <g data-name="Group 7662" clipPath="url(#i)" transform="translate(18.297 1.648)">
          <path
            data-name="Rectangle 2584"
            transform="rotate(-8.223 1.006 14.014)"
            fill="url(#a)"
            d="M0 0h12.798v15.499H0z"
          />
        </g>
      </g>
      <g data-name="Group 7665">
        <g data-name="Group 7664" clipPath="url(#j)" transform="translate(18.297 1.728)">
          <path
            data-name="Rectangle 2585"
            transform="rotate(-8.223 .998 13.936)"
            fill="url(#e)"
            d="M0 0h12.499v15.379H0z"
          />
        </g>
      </g>
      <g data-name="Group 7667">
        <g data-name="Group 7666" clipPath="url(#k)" transform="translate(22.262 4.351)">
          <path
            data-name="Rectangle 2586"
            transform="rotate(-8.223 .282 4.83)"
            fill="url(#l)"
            d="M0 0h5.825v5.113H0z"
          />
        </g>
      </g>
      <g data-name="Group 7669">
        <g data-name="Group 7668" clipPath="url(#k)" transform="translate(22.262 4.351)">
          <path
            data-name="Rectangle 2587"
            transform="rotate(-8.223 .282 4.83)"
            fill="url(#m)"
            d="M0 0h5.825v5.113H0z"
          />
        </g>
      </g>
      <g data-name="Group 7671">
        <g data-name="Group 7670" clipPath="url(#n)" transform="translate(13.35)">
          <path
            data-name="Rectangle 2588"
            transform="rotate(-8.223 .293 4.097)"
            fill="url(#b)"
            d="M0 0h13.743v5.975H0z"
          />
        </g>
      </g>
      <g data-name="Group 7685">
        <g data-name="Group 7684" clipPath="url(#f)">
          <g
            data-name="Group 7674"
            opacity={0.5}
            style={{
              mixBlendMode: 'multiply',
              isolation: 'isolate'
            }}>
            <g data-name="Group 7673">
              <g data-name="Group 7672" clipPath="url(#o)" transform="translate(22.362 4.306)">
                <path
                  data-name="Path 10206"
                  d="M.01.624c-.063 1.205.172 2.892.64 2.472s1.735.312 2.828-.162S4.425.592 2.606.127a2.471 2.471 0 0 0-2.6.5"
                  fill="#b82774"
                />
              </g>
            </g>
          </g>
          <g
            data-name="Group 7677"
            opacity={0.5}
            style={{
              mixBlendMode: 'multiply',
              isolation: 'isolate'
            }}>
            <g data-name="Group 7676">
              <g data-name="Group 7675" clipPath="url(#p)" transform="translate(14.116 4.02)">
                <path
                  data-name="Path 10207"
                  d="M.012.363c.222-1.744 3.254 3.129 3.689 7.431s-.8 5.428-1.37 5.054S-.169 1.788.012.363"
                  fill="#b82774"
                />
              </g>
            </g>
          </g>
          <g
            data-name="Group 7680"
            opacity={0.5}
            style={{
              mixBlendMode: 'multiply',
              isolation: 'isolate'
            }}>
            <g data-name="Group 7679">
              <g data-name="Group 7678" clipPath="url(#q)" transform="translate(17.358 17.143)">
                <path
                  data-name="Path 10208"
                  d="M.156.345C-.586.193 1.507-.028 2.433.016S4.598 0 4.598 0A24.555 24.555 0 0 1 .156.345"
                  fill="#b82774"
                />
              </g>
            </g>
          </g>
          <g
            data-name="Group 7683"
            opacity={0.5}
            style={{
              mixBlendMode: 'multiply',
              isolation: 'isolate'
            }}>
            <g data-name="Group 7682">
              <g data-name="Group 7681" clipPath="url(#r)" transform="translate(23.319 4.852)">
                <path
                  data-name="Path 10209"
                  d="M6.957.002c.412 2.515-.119 5.424-1.654 6.942-1.189 1.179-5.3 1.38-5.3 1.38s3.687-.477 4.786-1.39c1.91-1.6 2.2-4.224 2.171-6.932"
                  fill="#b82774"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <g data-name="Group 7687">
        <g data-name="Group 7686" clipPath="url(#s)" transform="translate(22.946 7.635)">
          <path
            data-name="Rectangle 2594"
            transform="rotate(-8.223 .094 1.314)"
            fill="url(#t)"
            d="M0 0h3.11v1.727H0z"
          />
        </g>
      </g>
      <g data-name="Group 7695">
        <g data-name="Group 7694" clipPath="url(#f)">
          <g
            data-name="Group 7690"
            opacity={0.8}
            style={{
              mixBlendMode: 'multiply',
              isolation: 'isolate'
            }}>
            <g data-name="Group 7689">
              <g data-name="Group 7688" clipPath="url(#u)" transform="translate(18.297 1.648)">
                <path
                  data-name="Path 10211"
                  d="M10.517 3.4c-.044.207-.117.325-.213.3-.537-.142-.75-3.574-4.252-3.276S.517 4.084.182 3.493A32.908 32.908 0 0 1 0 1.925 27.558 27.558 0 0 1 5.7.15h.029a5.76 5.76 0 0 1 .258-.041 5.339 5.339 0 0 1 2.706.107c.817.331 1.486 1.435 1.785 2.945.015.08.031.163.043.243"
                  fill="#b82774"
                />
              </g>
            </g>
          </g>
          <g
            data-name="Group 7693"
            opacity={0.8}
            style={{
              mixBlendMode: 'multiply',
              isolation: 'isolate'
            }}>
            <g data-name="Group 7692">
              <g data-name="Group 7691" clipPath="url(#v)" transform="translate(21.419 7.615)">
                <path
                  data-name="Path 10212"
                  d="M0 2.089a3.772 3.772 0 0 0 3.133.244A6.4 6.4 0 0 0 6.398 0a4.629 4.629 0 0 1-3.171 2.984c-2.47.608-3.228-.895-3.228-.895"
                  fill="#b82774"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <g data-name="Group 7697">
        <g data-name="Group 7696" clipPath="url(#w)" transform="translate(21.196 9.835)">
          <path
            data-name="Rectangle 2598"
            transform="rotate(-8.223 .152 2.171)"
            fill="url(#x)"
            d="M0 0h7.275v3.166H0z"
          />
        </g>
      </g>
      <g data-name="Group 7702">
        <g data-name="Group 7701" clipPath="url(#f)">
          <path
            data-name="Path 10214"
            d="M15.569 3.284a6.578 6.578 0 0 0 1.24-.062 12.582 12.582 0 0 0 1.275-.78 3.591 3.591 0 0 0-2.515.842"
            fill="#ffffdb"
          />
          <g
            data-name="Group 7700"
            style={{
              mixBlendMode: 'soft-light',
              isolation: 'isolate'
            }}>
            <g data-name="Group 7699">
              <g data-name="Group 7698" clipPath="url(#y)" transform="translate(21.661 11.808)">
                <path
                  data-name="Path 10215"
                  d="M.099.022C-.175.061.19.807.294.873s.9-.52.754-.7S.397-.016.099.027"
                  fill="#ffffdb"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <g data-name="Group 7704">
        <g data-name="Group 7703" clipPath="url(#z)" transform="translate(20.318 15.3)">
          <path
            data-name="Rectangle 2601"
            transform="rotate(-8.223 .022 .575)"
            fill="url(#A)"
            d="M0 0h1.719v.7H0z"
          />
        </g>
      </g>
      <g data-name="Group 7706">
        <g data-name="Group 7705" clipPath="url(#B)" transform="translate(2.312 2.861)">
          <path
            data-name="Rectangle 2602"
            transform="rotate(-8.223 1.081 16.375)"
            fill="url(#C)"
            d="M0 0h12.768v17.142H0z"
          />
        </g>
      </g>
      <g data-name="Group 7708">
        <g data-name="Group 7707" clipPath="url(#D)" transform="translate(0 4.36)">
          <path
            data-name="Rectangle 2603"
            transform="rotate(-8.223 .51 10.7)"
            fill="url(#E)"
            d="M0 0h8.921v9.963H0z"
          />
        </g>
      </g>
      <g data-name="Group 7710">
        <g data-name="Group 7709" clipPath="url(#F)" transform="translate(1.995 2.928)">
          <path
            data-name="Rectangle 2604"
            transform="rotate(-8.223 .567 26.064)"
            fill="url(#G)"
            d="M0 0h19.809v19.406H0z"
          />
        </g>
      </g>
      <g data-name="Group 7712">
        <g data-name="Group 7711" clipPath="url(#H)" transform="translate(3.833 5.053)">
          <path
            data-name="Rectangle 2605"
            transform="rotate(-8.223 .902 13.132)"
            fill="url(#I)"
            d="M0 0h13.708v14.484H0z"
          />
        </g>
      </g>
      <g data-name="Group 7714">
        <g data-name="Group 7713" clipPath="url(#J)" transform="translate(3.833 5.465)">
          <path
            data-name="Rectangle 2606"
            transform="rotate(-8.223 .856 12.5)"
            fill="url(#K)"
            d="M0 0h12.857v13.739H0z"
          />
        </g>
      </g>
      <g data-name="Group 7716">
        <g data-name="Group 7715" clipPath="url(#L)" transform="translate(10.38 16.461)">
          <path
            data-name="Rectangle 2607"
            transform="rotate(-8.223 .154 2.137)"
            fill="url(#M)"
            d="M0 0h5.202v2.83H0z"
          />
        </g>
      </g>
      <g data-name="Group 7718">
        <g data-name="Group 7717" clipPath="url(#N)" transform="translate(1.956 4.19)">
          <path
            data-name="Rectangle 2608"
            transform="rotate(-8.223 .184 2.6)"
            fill="url(#O)"
            d="M0 0h6.925v3.531H0z"
          />
        </g>
      </g>
      <g data-name="Group 7720">
        <g data-name="Group 7719" clipPath="url(#P)" transform="translate(8.335 2.872)">
          <path
            data-name="Rectangle 2609"
            transform="rotate(-8.223 .186 4.712)"
            fill="url(#Q)"
            d="M0 0h5.13v4.284H0z"
          />
        </g>
      </g>
      <g data-name="Group 7734">
        <g data-name="Group 7733" clipPath="url(#f)">
          <g
            data-name="Group 7723"
            opacity={0.5}
            style={{
              mixBlendMode: 'multiply',
              isolation: 'isolate'
            }}>
            <g data-name="Group 7722">
              <g data-name="Group 7721" clipPath="url(#R)" transform="translate(.244 9.953)">
                <path
                  data-name="Path 10225"
                  d="M0 .331c.081-1.54 5.538 2.8 5.538 2.8a4.639 4.639 0 0 1-1.58-.253C3.461 2.618.869 1.381 0 .331"
                  fill="#b82774"
                />
              </g>
            </g>
          </g>
          <g
            data-name="Group 7726"
            opacity={0.5}
            style={{
              mixBlendMode: 'multiply',
              isolation: 'isolate'
            }}>
            <g data-name="Group 7725">
              <g data-name="Group 7724" clipPath="url(#S)" transform="translate(10.379 16.635)">
                <path
                  data-name="Path 10226"
                  d="M0 .431s.556-.557.8-.4a21.469 21.469 0 0 1 2.382 1.626A27.5 27.5 0 0 1 .004.436"
                  fill="#b82774"
                />
              </g>
            </g>
          </g>
          <g
            data-name="Group 7729"
            opacity={0.5}
            style={{
              mixBlendMode: 'multiply',
              isolation: 'isolate'
            }}>
            <g data-name="Group 7728">
              <g data-name="Group 7727" clipPath="url(#T)" transform="translate(2.312 15.848)">
                <path
                  data-name="Path 10227"
                  d="M7.144 2.313c-1.011 1.16-1.8 1.914-2.094 1.833a6.688 6.688 0 0 1-2.545-1.374 2.636 2.636 0 0 1-.212-.207C1.282 1.589-.097.681.005.001a12.491 12.491 0 0 0 2.127 2.371 6.167 6.167 0 0 0 .526.4c.1.068.191.132.288.192a3.356 3.356 0 0 0 4.2-.655"
                  fill="#b82774"
                />
              </g>
            </g>
          </g>
          <g
            data-name="Group 7732"
            opacity={0.3}
            style={{
              mixBlendMode: 'soft-light',
              isolation: 'isolate'
            }}>
            <g data-name="Group 7731">
              <g data-name="Group 7730" clipPath="url(#U)" transform="translate(.238 5.041)">
                <path
                  data-name="Path 10228"
                  d="M0 4.244c.148.722 1.342.515 1.553.156a9.258 9.258 0 0 1 1.033-3.209C3.686-.789.468-.634 0 4.244"
                  fill="#ffffb1"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <g data-name="Group 7736">
        <g data-name="Group 7735" clipPath="url(#V)" transform="translate(12.07 7.619)">
          <path
            data-name="Rectangle 2615"
            transform="rotate(-8.223 .304 4.23)"
            fill="url(#W)"
            d="M0 0h3.493v4.629H0z"
          />
        </g>
      </g>
      <g data-name="Group 7738">
        <g data-name="Group 7737" clipPath="url(#X)" transform="translate(5.563 10.664)">
          <path
            data-name="Rectangle 2616"
            transform="rotate(-8.223 .124 1.778)"
            fill="url(#Y)"
            d="M0 0h2.755v2.13H0z"
          />
        </g>
      </g>
      <g data-name="Group 7746">
        <g data-name="Group 7745" clipPath="url(#f)">
          <g
            data-name="Group 7741"
            opacity={0.8}
            style={{
              mixBlendMode: 'multiply',
              isolation: 'isolate'
            }}>
            <g data-name="Group 7740">
              <g data-name="Group 7739" clipPath="url(#Z)" transform="translate(3.833 5.053)">
                <path
                  data-name="Path 10231"
                  d="M11.203 2.235s-.534.519-.728.339-.337-1.716-1.7-1.073-2.162 4.608-2.738 4.557S3.596 3.87 2.546 3.419.328 2.573.208 4.444a1.074 1.074 0 0 1-.194-.879A4.217 4.217 0 0 1 .75 1.842c.1-.148.2-.285.3-.407.627.381 1.7 1.1 3.312 2.323l1.1.833.463.349 1.079-1.635c.894-1.348 1.561-2.284 2.034-2.9.122-.159.232-.3.327-.411a4.719 4.719 0 0 1 1.675 1.664 1.312 1.312 0 0 1 .164.571"
                  fill="#b82774"
                />
              </g>
            </g>
          </g>
          <path
            data-name="Path 10232"
            d="M12.508 2.871c-.415.43.743.635 1.107.573s-.466-.589-1.107-.573"
            fill="#ffffdb"
          />
          <path
            data-name="Path 10233"
            d="M3.999 4.407c-.654.239-.559.644-.25.713s1.475-.268 1.429-.458-.627-.457-1.18-.255"
            fill="#ffffdb"
          />
          <g
            data-name="Group 7744"
            style={{
              mixBlendMode: 'soft-light',
              isolation: 'isolate'
            }}>
            <g data-name="Group 7743">
              <g data-name="Group 7742" clipPath="url(#aa)" transform="translate(10.052 14.19)">
                <path
                  data-name="Path 10234"
                  d="M.342.006c-.174.025-.9 1.208.511.693C1.24.558.859-.069.342.006"
                  fill="#ffffdb"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
      <g data-name="Group 7748">
        <g data-name="Group 7747" clipPath="url(#ab)" transform="translate(14.05 15.366)">
          <path
            data-name="Rectangle 2620"
            transform="rotate(-8.22 .096 1.385)"
            fill="url(#ac)"
            d="M0 0h1.884v1.624H0z"
          />
        </g>
      </g>
      <g data-name="Group 7750">
        <g data-name="Group 7749" clipPath="url(#ad)" transform="translate(5.833 16.651)">
          <path
            data-name="Rectangle 2621"
            transform="rotate(-8.223 .12 1.638)"
            fill="url(#ae)"
            d="M0 0h2.71v1.99H0z"
          />
        </g>
      </g>
    </g>
  </svg>
);

export default SvgComponent;
